
import Vue from 'vue';
import { Component, InjectReactive, Prop } from 'vue-property-decorator';
import CPOpenAccountFormSubsection from '../open-account/form/CPOpenAccountFormSubsection.vue';
import { AccountHolderName } from '@/store/dueDiligence/types';
import { AccountTypeFlags } from '@/store/openAccount/types';
import { CPTextInput } from '@capital-platforms/cpui';

@Component({
    components: {
        CPOpenAccountFormSubsection,
        CPTextInput
    }
})
export default class CPDueDiligenceAccountHolderNameDetails extends Vue {
    @Prop({
        type: Object as () => AccountHolderName,
        required: true
    })
    accountName!: AccountHolderName;

    @InjectReactive() readonly accountType!: AccountTypeFlags;
    @InjectReactive() readonly viewOnly!: boolean;

}
